import React, { Component } from 'react'
import AppPopover from 'components/AppPopover'

interface IProps {
  getModuleIcon?: (e: any) => void
  currIcon?: string
}

let iconList = [
  'qcciconfont-module-organ',
  'qcciconfont-module-setting',
  'qcciconfont-module-planMng',
  'qcciconfont-module-shenbaoguanli',
  'qcciconfont-module-chaiqianguangli',
  'qcciconfont-module-caiwuguangli',
  'qcciconfont-module-organ',
  'qcciconfont-module-setting',
  'qcciconfont-module-planMng',
  'qcciconfont-module-shenbaoguanli',
  'qcciconfont-module-chaiqianguangli',
  'qcciconfont-module-caiwuguangli',
  'qcciconfont-module-organ',
  'qcciconfont-module-setting',
  'qcciconfont-module-planMng',
  'qcciconfont-module-shenbaoguanli',
  'qcciconfont-module-chaiqianguangli',
  'qcciconfont-module-caiwuguangli'
]
export default class ModuleNewModuleIcon extends Component<IProps> {
  render() {
    return (
      <div className="module-newmodule-icon">
        <span style={{ marginBottom: '5px', padding: '10px 10px 0' }}>
          系统图标
        </span>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            cursor: 'pointer'
          }}
        >
          {iconList.map((item, index) => {
            return (
              <div
                key={index}
                className="icon-item"
                onClick={this.props.getModuleIcon}
              >
                <i
                  className={item}
                  style={{
                    fontSize: '20px',
                    color: this.props.currIcon === item && '#34a6f8'
                  }}
                ></i>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/modeling/module/ModuleNewModuleIcon.tsx